


















import { Vue, Component, Prop } from 'vue-property-decorator';
import InputField from '@/components/common/inputs/InputField.vue';
import { DateTime } from 'luxon';

@Component({
  components: {
    InputField
  }
})
export default class DatePicker extends Vue {
  @Prop(Boolean) disabled!: boolean;
  @Prop(String) value!: string;

  format = 'yyyy/MM/dd';

  get inputValue() {
    const date = DateTime.fromISO(this.value);
    return date.isValid ? date.toFormat(this.format) : '';
  }

  onInputChange(date: string): void {
    if (!date) {
      this.$emit('change', '');
    } else if (date.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
      this.valueChanged(DateTime.fromFormat(date, this.format));
    }
  }

  onDatePickerChange(date: string): void {
    if (date) {
      this.valueChanged(DateTime.fromISO(date));
    }
  }

  valueChanged(date: DateTime): void {
    if (date.isValid) {
      this.$emit('change', date.toISO());
    }
  }
}
